module.exports = __webpack_public_path__ + "fonts/iconfont.804e9722.woff";